<template>
  <div class="flex items-start gap-3">
    <MediaImage
      v-if="!hideImage"
      v-bind="image"
      :image-style="imageStyle"
      hide-caption
      class="hidden sm:inline-block shrink-0"
      img-class="!w-auto"
    />
    <div class="">
      <span class="font-medium md:block leading-none mb-1">{{ name }}</span>
      <span v-if="addon">{{ addon }}</span>
      <LocationOpenStatus
        v-if="showStatus && id && !externalLocation"
        :id="id"
        class="block"
      />
      <div v-if="externalLocation">
        <FieldItemTypeAddress class="inline" v-bind="address" hide-maps-link />
      </div>
      <DrupalLink
        v-if="locationUrl && showLink"
        :to="locationUrl"
        class="link-underline block"
        >{{ $texts('location.go_to_link', 'Zum Standort') }}</DrupalLink
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  GlobalConfigFragment,
  LocationTeaserFragment,
  MediaImageFragment,
} from '#graphql-operations'

const props = defineProps<{
  // Props provided by the GraphQL fragment.
  id?: string
  name?: string
  image?: MediaImageFragment
  page?: LocationTeaserFragment['page']
  externalLocation?: boolean
  address?: GlobalConfigFragment['address']

  // Additional props.
  addon?: string
  showLink?: boolean
  showStatus?: boolean

  hideImage?: boolean
}>()

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    xs: 48,
    lg: 72,
  },
})

const locationUrl = computed(() => props.page?.url?.path)
</script>
